import { Resolver } from '@urql/exchange-graphcache';

import { SkillFromCacheQueryVariables } from '@/modules/org-hierarchy/modules/tracks/views/TrackDetails/graphql/queries/generated/trackFromCache';

export const skillDetailsResolver: Resolver<any, SkillFromCacheQueryVariables, any> = (_, args) => {
  return { __typename: 'SkillType', id: args.filters.id };
};
